import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ChecklistID, DealerID } from "models";

type DetachChecklistFromDealerPayload = {
  checklist_id: ChecklistID;
  dealer_id: DealerID;
};

export const useDetachChecklistFromDealerMutation = () =>
  useTypedMutation<DetachChecklistFromDealerPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/dealer/detach", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ checklist_id, dealer_id }) => {
      const dealerChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id));
      if (!dealerChecklists?.length) return;

      const checklistIdx = dealerChecklists.findIndex(dc => dc.id === checklist_id);
      if (checklistIdx === -1) return;

      typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id), dealerChecklists.toSpliced(checklistIdx, 1));
    }
  });
